module.exports = __webpack_public_path__ + "static/media/main24.1d4a95ba.png";